import { routes } from '@/lib/constants';

export interface ProductTourStep {
  id: string;
  route: string;
  element: string;
  title: string;
  description: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
}

export const PRODUCT_TOUR_STEPS: ProductTourStep[] = [
  {
    id: 'welcome',
    route: routes.root,
    element: '[data-tour="dashboard-overview"]',
    title: 'Welcome to Sellyt',
    description:
      'This quick tour shows you how to get set up — from verification to your first sale. You can skip anytime or use Next to follow along.',
    side: 'bottom',
    align: 'start',
  },
  {
    id: 'kyb',
    route: routes.root,
    element: '[data-tour="nav-kyb"]',
    title: 'Verify your business (KYB)',
    description:
      'Complete KYB verification first. It confirms your business identity, unlocks secure payouts, and builds trust with customers.',
    side: 'right',
  },
  {
    id: 'bank',
    route: routes.root,
    element: '[data-tour="nav-settings"]',
    title: 'Add bank account details',
    description:
      'Open Account Settings → Bank Information to add your payout account so you can receive earnings from orders.',
    side: 'right',
  },
  {
    id: 'store',
    route: routes.root,
    element: '[data-tour="nav-store"]',
    title: 'Create your store',
    description:
      'Build your online storefront here. It only takes a few minutes and gives customers a branded place to shop.',
    side: 'right',
  },
  {
    id: 'products',
    route: routes.root,
    element: '[data-tour="nav-products"]',
    title: 'Add products',
    description:
      'Once your store exists, add products with photos, prices, and descriptions so buyers can place orders.',
    side: 'right',
  },
  {
    id: 'orders',
    route: routes.root,
    element: '[data-tour="nav-orders"]',
    title: 'Manage orders',
    description:
      'View and fulfill customer orders here — track status, update progress, and keep every sale moving from checkout to delivery.',
    side: 'right',
  },
  {
    id: 'conversations',
    route: routes.root,
    element: '[data-tour="nav-conversations"]',
    title: 'Connect your conversations',
    description:
      'Link Instagram or Facebook to manage DMs in one inbox and turn chats into orders without switching apps.',
    side: 'right',
  },
  {
    id: 'ai',
    route: routes.conversations,
    element: '[data-tour="ai-auto-followup"]',
    title: 'Automate replies with AI',
    description:
      'Enable AI Auto Follow-up on the Conversations page so customer DMs get timely, on-brand responses even when you are away.',
    side: 'bottom',
    align: 'start',
  },
  {
    id: 'shipping',
    route: routes.root,
    element: '[data-tour="nav-shipping"]',
    title: 'Set up shipping & pickup',
    description:
      'Configure delivery fees and pickup locations so customers know how orders reach them — whether you ship or they collect in person.',
    side: 'right',
  },
  {
    id: 'transactions',
    route: routes.root,
    element: '[data-tour="nav-transactions"]',
    title: 'Monitor transactions',
    description:
      'Track payments and order activity in Transactions so you always know what was paid, pending, or failed.',
    side: 'right',
  },
  {
    id: 'billing',
    route: routes.root,
    element: '[data-tour="nav-billing"]',
    title: 'Manage billing',
    description:
      'View your subscription plan, upgrade when you are ready, and download receipts from billing history.',
    side: 'right',
  },
  {
    id: 'finish',
    route: routes.root,
    element: '[data-tour="dashboard-overview"]',
    title: 'You are all set',
    description:
      'You now know where everything lives. Whenever you need a refresher, tap the map icon in the top bar to run this tour again.',
    side: 'bottom',
    align: 'start',
  },
];

export const PRODUCT_TOUR_STEP_COUNT = PRODUCT_TOUR_STEPS.length;
